import React from 'react'
import PropTypes from 'prop-types'
// styles
import './styles.al.scss'
import SvgArrow from './svgArrow'

const ArrowLinks = (props) => {
  const {
    isAnchor = false,
    href = '/#',
    onClick: onClickComp,
    textLink = 'Lorem ipsum',
    hoverLink,
    keyId,
    altLink,
    isActive,
    target = '_parent',
    classNameLabel = '',
  } = props

  const hambleClick = () => {
    if (onClickComp) {
      onClickComp()
    }
  }

  if (isAnchor) {
    return (
      <button
        onMouseEnter={() => hoverLink && hoverLink(keyId, true)}
        onMouseLeave={() => hoverLink && hoverLink(keyId, false)}
        onClick={() => hambleClick()}
        className="containerArrowLinks btn"
      >
        <label className={`${classNameLabel || ''}`}>{textLink}</label>
        <div className="containerArrow">
          <SvgArrow className="svgArrow rotate-90" />
        </div>
      </button>
    )
  }

  return (
    <a
      onMouseEnter={() => hoverLink && hoverLink(keyId, true)}
      onMouseLeave={() => hoverLink && hoverLink(keyId, false)}
      className={`containerArrowLinks ${isActive ? 'arrowLinksActive' : ''}`}
      target={target}
      alt={altLink}
      href={href}
    >
      <label className={`${classNameLabel || ''}`}>{textLink}</label>
      <div className="containerArrow">
        <SvgArrow className="svgArrow" />
      </div>
    </a>
  )
}

ArrowLinks.propTypes = {
  isAnchor: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  textLink: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  hoverLink: PropTypes.func,
  keyId: PropTypes.number,
  altLink: PropTypes.string,
  isActive: PropTypes.bool,
  target: PropTypes.string,
  classNameLabel: PropTypes.string,
}

export default ArrowLinks
